import './style.scss';

import { useEffect, useState } from 'react';

interface AnimatedNumberProps {
	value: number;
	duration?: number;
	formatValue?: (value: number) => string;
}

const AnimatedNumber = ({ value, duration = 1000, formatValue }: AnimatedNumberProps) => {
	const [displayValue, setDisplayValue] = useState(0);

	useEffect(() => {
		let startTime: number;
		let animationFrame: number;

		const animate = (currentTime: number) => {
			if (!startTime) startTime = currentTime;
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1);

			// Easing function for smooth animation
			const easeOutQuart = 1 - Math.pow(1 - progress, 4);
			const currentValue = Math.floor(easeOutQuart * value);

			setDisplayValue(currentValue);

			if (progress < 1) {
				animationFrame = requestAnimationFrame(animate);
			} else {
				setDisplayValue(value);
			}
		};

		animationFrame = requestAnimationFrame(animate);

		return () => {
			if (animationFrame) {
				cancelAnimationFrame(animationFrame);
			}
		};
	}, [value, duration]);

	const formattedValue = formatValue ? formatValue(displayValue) : displayValue.toLocaleString();

	return <span className='animated-number'>{formattedValue}</span>;
};

export default AnimatedNumber;
